import t from "../locales";
import { Link } from "react-router-dom";
import inti from "../assets/images/inti.png";
import treeLogo from "../assets/images/tree_logo_color.svg";

export default function Start() {
  return (
    <div className="screen-generic">
      <div className="screen-generic__top-image-container">
        <span className="screen-generic__top-image-copyright">
          © Lies Willaert
        </span>
        <img src={inti} alt="inti" className="screen-generic__top-image" />
      </div>
      <div className="screen-generic__content">
        <p className="screen-generic__text">
          {t("screens_start_instructions")}
        </p>
        <Link className="button" to={"/info"}>
          {t("screens_start_button_text")}
        </Link>
      </div>
      <div className="screen-generic__footer">
        <img
          src={treeLogo}
          alt={t("logo_tree")}
          className="screen-generic__logo"
        />
      </div>
    </div>
  );
}
